import {LocalizationStrings} from "../../../i18n/i18n-model";
import {replaceAnchors} from "../../../tools/replace-anchors/replace-anchors";
import {SleepReportData} from "./sleep-report-data";
import {formatPercentage, formatReportNumber} from "./sleep-report-formatting";

export function withGeneratedFindings(
  sleepReportData: SleepReportData,
  translate: (key: keyof LocalizationStrings) => string
): SleepReportData {
  const generatedFindings = sleepFindingsText(sleepReportData, translate);
  const doctorFindings = sleepReportData.findings.findings;

  return {
    ...sleepReportData,
    findings: {
      ...sleepReportData.findings,
      findings: doctorFindings?.trim() ? `${generatedFindings} ${doctorFindings}` : generatedFindings
    }
  };
}

export function sleepFindingsText(
  sleepReportData: SleepReportData,
  translate: (key: keyof LocalizationStrings) => string
): string {
  const measurements = sleepReportData.externalFindings.measurements;
  const reportLanguage = sleepReportData.metadata.reportLanguage;
  const number = (value: string) => formatReportNumber(value, reportLanguage);
  const percentage = (value: string) => formatPercentage(number(value));

  return [
    translate("sleepReportSentenceTechnicallySuccessful"),
    replaceAnchors(translate("sleepReportSentenceAhi"), {
      ahi: number(measurements.ahiIndex),
      supineAhi: number(measurements.positions.supine.ahiIndex)
    }),
    replaceAnchors(translate("sleepReportSentenceOdi3"), {odi3: number(measurements.odi3Index)}),
    replaceAnchors(translate("sleepReportSentenceOxygenSaturation"), {
      average: percentage(measurements.o2Levels.spO2Average),
      minimum: percentage(measurements.o2Levels.spO2Minimum),
      below90: percentage(measurements.o2Levels.spO2Percentage)
    }),
    replaceAnchors(translate("sleepReportSentenceSnoring"), {
      snoring: percentage(measurements.snoringPercentage)
    })
  ].join(" ");
}
